import { formatMaterialNumber } from '../../../../../utils/DateAndNumberFunctions';
import { getMrpNdToPdV1SpecialRule } from '../../../../../utils/mrpSpecialRules';


// eslint-disable-next-line import/prefer-default-export
export const getDeliveryTimePayloadForSingleMaterial = (plant, relatedPlants, mrpsForRelatedPlants, materialData, material, newData) => {
  const correctRelatedPlants = relatedPlants[plant] ?? [];
  const correctMrpsForRelatedPlants = mrpsForRelatedPlants.filter((mrp) => correctRelatedPlants.some((plant) => plant.Plant_ID === mrp.Plant));

  const toNdChange = newData.some((object) => object.key === 'MRPType' && object.userDefined === 'ND' && object.current !== 'ND');
  const fromNdChange = newData.some((object) => object.key === 'MRPType' && (object.userDefined === 'V1' || object.userDefined === 'PD') && object.current === 'ND');
  const { supplier } = materialData;
  const deliveryTimePayload = { MrpBatch: '123', to_Mrp: [] };
  const preSchedulingChanges = [];
  const addOrMergeChange = (changeObject) => {
    const existing = deliveryTimePayload.to_Mrp.find(
      (item) => item.MaterialNumber?.toString() === changeObject.MaterialNumber?.toString()
        && item.Plant?.toString() === changeObject.Plant?.toString(),
    );

    if (existing) {
      Object.assign(existing, changeObject);
      return;
    }

    deliveryTimePayload.to_Mrp.push(changeObject);
  };

  const allMrps = [...(mrpsForRelatedPlants || [])];

  const getMrpForPlant = (targetPlant, materialNumber) => allMrps.find(
    (mrp) => mrp.Plant?.toString() === targetPlant?.toString()
      && formatMaterialNumber(mrp.MaterialNumber)?.toString() === materialNumber?.toString(),
  );

  const isBlank = (value) => value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '');

  const addOrMergePreSchedulingChange = (changeObject) => {
    const existing = preSchedulingChanges.find(
      (item) => item.MaterialNumber?.toString() === changeObject.MaterialNumber?.toString()
        && item.Plant?.toString() === changeObject.Plant?.toString(),
    );

    if (existing) {
      Object.assign(existing, changeObject);
      return;
    }

    preSchedulingChanges.push(changeObject);
  };

  if (toNdChange) {
    if (plant === supplier) {
      const onshoreDeliveryTime = mrpsForRelatedPlants.find(
        (mrpSetting) => mrpSetting.Plant === plant
              && formatMaterialNumber(mrpSetting.MaterialNumber) === material,
      )?.PlannedDeliveryTimeInDays;
      if (onshoreDeliveryTime) {
        correctRelatedPlants?.forEach((relatedPlant) => {
          const materialNumber = formatMaterialNumber(material);
          if (mrpsForRelatedPlants?.some((mrp) => mrp.Plant === relatedPlant.Plant_ID && formatMaterialNumber(mrp.MaterialNumber) === materialNumber)) {
            const changeObject = {
              MaterialNumber: materialNumber,
              Plant: relatedPlant.Plant_ID,
              PlannedDeliveryTimeInDays: String(onshoreDeliveryTime),
              PlannedDeliveryTimeInDays_X: true,
            };
            deliveryTimePayload.to_Mrp.push(changeObject);
          }
        });
      }
    }
  }

  const allPlants = { [plant]: [...correctRelatedPlants, { Plant_ID: plant }] };

  if (fromNdChange) {
    const materialNumber = formatMaterialNumber(material);
    const activeSpecialRule = getMrpNdToPdV1SpecialRule(plant);

    // Standard rule: set SpecialProcurementType to 40 for related plants.
    // For configured special plants, only explicit special pairs should be updated.
    if (!activeSpecialRule) {
      allPlants[plant].forEach((relPlant) => {
        if (relPlant.Plant_ID !== supplier) {
          const mrpPlant = getMrpForPlant(relPlant.Plant_ID, materialNumber);
          if (mrpPlant) {
            if (!mrpPlant.SpecialProcurementType || mrpPlant.SpecialProcurementType === '') {
              const changeObject = {
                MaterialNumber: materialNumber,
                Plant: relPlant.Plant_ID,
                SpecialProcurementType_X: true,
                SpecialProcurementType: '40',
              };
              addOrMergeChange(changeObject);
            }
          }
        }
      });
    }

    if (activeSpecialRule) {
      (activeSpecialRule.preSchedulingMarginTargetsIfBlank || []).forEach((targetPlant) => {
        const mrpDataForPlant = getMrpForPlant(targetPlant, materialNumber);
        // Skip if this plant is also in specialProcurementPlants; scheduling margin will ride on that change.
        if (mrpDataForPlant && isBlank(mrpDataForPlant.SchedulingMarginKeyFloats)
          && !(activeSpecialRule.specialProcurementPlants || []).includes(targetPlant)) {
          addOrMergePreSchedulingChange({
            MaterialNumber: materialNumber,
            Plant: targetPlant,
            SchedulingMarginKeyFloats_X: true,
            SchedulingMarginKeyFloats: '001',
          });
        }
      });

      activeSpecialRule.specialProcurementPlants.forEach((targetPlant) => {
        const mrpDataForPlant = getMrpForPlant(targetPlant, materialNumber);
        if (mrpDataForPlant
          && (!mrpDataForPlant.SpecialProcurementType || mrpDataForPlant.SpecialProcurementType === '')) {
          const changeObject = {
            MaterialNumber: materialNumber,
            Plant: targetPlant,
            SpecialProcurementType_X: true,
            SpecialProcurementType: '40',
          };

          if ((activeSpecialRule.preSchedulingMarginTargetsIfBlank || []).includes(targetPlant)
            && isBlank(mrpDataForPlant.SchedulingMarginKeyFloats)) {
            changeObject.SchedulingMarginKeyFloats_X = true;
            changeObject.SchedulingMarginKeyFloats = '001';
          }

          addOrMergeChange(changeObject);
        }
      });

      (activeSpecialRule.plannedDeliveryTargets || []).forEach((targetRule) => {
        const mrpDataForPlant = getMrpForPlant(targetRule.plant, materialNumber);
        if (mrpDataForPlant
          && mrpDataForPlant.PlannedDeliveryTimeInDays?.toString()
            !== targetRule.plannedDeliveryTimeInDays?.toString()) {
          addOrMergeChange({
            MaterialNumber: materialNumber,
            Plant: targetRule.plant,
            PlannedDeliveryTimeInDays_X: true,
            PlannedDeliveryTimeInDays: `${targetRule.plannedDeliveryTimeInDays}`,
          });
        }
      });

      if (plant?.toString() === '1494') {
        const mrpDataForTriggerPlant = getMrpForPlant(plant, materialNumber);
        if (mrpDataForTriggerPlant && isBlank(mrpDataForTriggerPlant.SchedulingMarginKeyFloats)) {
          addOrMergeChange({
            MaterialNumber: materialNumber,
            Plant: plant,
            SchedulingMarginKeyFloats_X: true,
            SchedulingMarginKeyFloats: '001',
          });
        }
      }

      activeSpecialRule.pdTargets.forEach((targetRule) => {
        const targetPlant = targetRule.plant;
        const mrpDataForPlant = getMrpForPlant(targetPlant, materialNumber);
        if (mrpDataForPlant) {
          if (targetRule.onlyIfMrpType && mrpDataForPlant.MRPType !== targetRule.onlyIfMrpType) {
            return;
          }

          const shouldSetMrpType = mrpDataForPlant.MRPType !== 'PD';
          const shouldSetLotSize = mrpDataForPlant.LotSize !== 'EX';
          const shouldSetController = targetRule.setMrpControllerIfBlank && isBlank(mrpDataForPlant.MRPController);
          const shouldSetSchedulingMargin = targetRule.setSchedulingMarginIfBlank
            && isBlank(mrpDataForPlant.SchedulingMarginKeyFloats);

          if (shouldSetMrpType || shouldSetLotSize || shouldSetController || shouldSetSchedulingMargin) {
            const changeObject = {
              MaterialNumber: materialNumber,
              Plant: targetPlant,
            };

            if (shouldSetMrpType) {
              changeObject.MRPType_X = true;
              changeObject.MRPType = 'PD';
            }

            if (shouldSetLotSize) {
              changeObject.LotSize_X = true;
              changeObject.LotSize = 'EX';
            }

            if (shouldSetController) {
              changeObject.MRPController_X = true;
              changeObject.MRPController = targetRule.mrpControllerValue || '000';
            }

            if (shouldSetSchedulingMargin) {
              changeObject.SchedulingMarginKeyFloats_X = true;
              changeObject.SchedulingMarginKeyFloats = '001';
            }

            addOrMergeChange(changeObject);
          }
        }
      });
    }
  }

  if (preSchedulingChanges.length > 0) {
    deliveryTimePayload.to_Mrp = [...preSchedulingChanges, ...deliveryTimePayload.to_Mrp];
  }

  return deliveryTimePayload;
};
